import { useAgGridTableContext } from 'core/states';
import { AddProjectButton as BaseAddProjectButton } from 'projects/components';

export const AddProjectButton = () => {
  const { gridApi } = useAgGridTableContext();

  const onAddProjectSuccess = () => gridApi?.refreshServerSide();

  return <BaseAddProjectButton onAddProjectSuccess={onAddProjectSuccess} />;
};
